/*
Mike Rodriguez
LWTech
JavaScript
Final Project
*/
import React from 'react';
import ReactDOM from 'react-dom';
// importing App file to render it below
import App from './App';

// rendering the App to the Element ID root used in index.html
ReactDOM.render(<App />, document.getElementById('root'));